import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import './TrialNotification.css'; 

const TrialNotification = ({ isPremium, isTrialActive, daysLeftInTrial, hasPendingPaymentProof }) => {
	const navigate = useNavigate();
	
	// Determine the message and action
    let message = '';
    let actionButton = null;
    let notificationClass = ''; // For styling
	
    if (isPremium) {
        message = "You are currently a Premium member! Enjoy all features.";
        notificationClass = 'premium-active';
        // Action button could be "Manage Subscription"
        actionButton = (
            <button onClick={() => navigate('/account-history')}>Manage Subscription</button>
        );
    } else if (isTrialActive) {
        if (daysLeftInTrial > 0) {
            message = `Your free trial is active! ${daysLeftInTrial} day(s) left.`;
            notificationClass = 'trial-active';
            actionButton = (
                <button onClick={() => navigate('/premium')}>Upgrade Now</button>
            );
        } else {
            message = "Your free trial ends today!";
            notificationClass = 'trial-ending-soon';
            actionButton = (
                <button onClick={() => navigate('/premium')}>Upgrade Now</button>
            );
        }
    } else if (hasPendingPaymentProof) {
        message = "Your payment is under review. We'll activate your Premium access soon!";
        notificationClass = 'payment-pending';
        // No action button here, as user needs to wait
    } else { // Trial ended, not premium, no pending payment
        message = "Your subscription has ended. Please upgrade to continue accessing premium features.";
        notificationClass = 'trial-ended';
        actionButton = (
            <button onClick={() => navigate('/premium')}>Upgrade to Premium</button>
        );
    }

    return (
        <div className={`trial-notification ${notificationClass}`}>
            <p>{message}</p>
            {actionButton}
        </div>
    );
};

export default TrialNotification;